module.exports = "https://coopqualityrds.pw/api/";
